var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "acg-page" }, [
    _vm.showForm
      ? _c("div", [
          _vm._m(0),
          _c("div", { staticClass: "member custom-container-xl" }, [
            _c("div", { staticClass: "member__box" }, [
              _vm._m(1),
              _c("div", { staticClass: "personal__info" }, [
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("出生日期")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "item__input",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.dateModal = true
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.birthDate))]),
                      _c(
                        "v-dialog",
                        {
                          ref: "dialogDate",
                          attrs: {
                            "return-value": _vm.birthDate,
                            width: "290px",
                            persistent: ""
                          },
                          on: {
                            "update:returnValue": function($event) {
                              _vm.birthDate = $event
                            },
                            "update:return-value": function($event) {
                              _vm.birthDate = $event
                            }
                          },
                          model: {
                            value: _vm.dateModal,
                            callback: function($$v) {
                              _vm.dateModal = $$v
                            },
                            expression: "dateModal"
                          }
                        },
                        [
                          _c(
                            "v-date-picker",
                            {
                              staticClass: "picker date-picker",
                              attrs: {
                                "first-day-of-week": 0,
                                locale: "zh-cn",
                                scrollable: "",
                                "header-color": "rgba(217, 217, 217, 0.25)",
                                color: "primary",
                                max: "2099-12-31",
                                min: "0676-01-01"
                              },
                              model: {
                                value: _vm.birthDate,
                                callback: function($$v) {
                                  _vm.birthDate = $$v
                                },
                                expression: "birthDate"
                              }
                            },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "error" },
                                  on: {
                                    click: function($event) {
                                      _vm.dateModal = false
                                    }
                                  }
                                },
                                [_vm._v("取消")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "error" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.dialogDate.save(
                                        _vm.birthDate
                                      )
                                    }
                                  }
                                },
                                [_vm._v("確認")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("出生時間")
                  ]),
                  _c("div", { staticClass: "time-wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "item__input",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.timeModal = true
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.birthTime))]),
                        _c(
                          "v-dialog",
                          {
                            ref: "dialogTime",
                            attrs: {
                              "return-value": _vm.birthTime,
                              width: "290px",
                              persistent: ""
                            },
                            on: {
                              "update:returnValue": function($event) {
                                _vm.birthTime = $event
                              },
                              "update:return-value": function($event) {
                                _vm.birthTime = $event
                              }
                            },
                            model: {
                              value: _vm.timeModal,
                              callback: function($$v) {
                                _vm.timeModal = $$v
                              },
                              expression: "timeModal"
                            }
                          },
                          [
                            _vm.timeModal
                              ? _c(
                                  "v-time-picker",
                                  {
                                    staticClass: "picker time-picker",
                                    attrs: {
                                      scrollable: "",
                                      "ampm-in-title": "",
                                      "header-color":
                                        "rgba(217, 217, 217, 0.25)",
                                      color: "primary"
                                    },
                                    model: {
                                      value: _vm.birthTime,
                                      callback: function($$v) {
                                        _vm.birthTime = $$v
                                      },
                                      expression: "birthTime"
                                    }
                                  },
                                  [
                                    _c("v-spacer"),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "error" },
                                        on: {
                                          click: function($event) {
                                            _vm.timeModal = false
                                          }
                                        }
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "error" },
                                        on: {
                                          click: function($event) {
                                            return _vm.$refs.dialogTime.save(
                                              _vm.birthTime
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("確認")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("label", { staticClass: "checkbox-wrap" }, [
                      _vm._v("\n                我不知道\n                "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.IDontKnow,
                            expression: "IDontKnow"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.IDontKnow)
                            ? _vm._i(_vm.IDontKnow, null) > -1
                            : _vm.IDontKnow
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.IDontKnow,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.IDontKnow = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.IDontKnow = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.IDontKnow = $$c
                            }
                          }
                        }
                      }),
                      _c("span", { staticClass: "checkmark" })
                    ])
                  ])
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("日光節約時間")
                  ]),
                  _c("div", { staticClass: "item__sex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "sex-box male",
                        class: { activeSex: _vm.IsDaylight },
                        on: {
                          click: function($event) {
                            _vm.IsDaylight = true
                          }
                        }
                      },
                      [_vm._v("\n                是\n              ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "sex-box female",
                        class: { activeSex: !_vm.IsDaylight },
                        on: {
                          click: function($event) {
                            _vm.IsDaylight = false
                          }
                        }
                      },
                      [_vm._v("\n                否\n              ")]
                    )
                  ])
                ]),
                _c("div", { staticClass: "personal__item" }, [
                  _c("span", { staticClass: "item__title" }, [
                    _vm._v("出生地點")
                  ]),
                  _c(
                    "div",
                    { staticClass: "item__input" },
                    [
                      _c("v-autocomplete", {
                        staticClass: "select",
                        attrs: {
                          items: _vm.cityList,
                          label: "請選擇或輸入出生地點",
                          "background-color": "transparent",
                          solo: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.birthCity,
                          callback: function($$v) {
                            _vm.birthCity = $$v
                          },
                          expression: "birthCity"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "personal__btns" }, [
                _c(
                  "div",
                  {
                    staticClass: "personal__save",
                    class: { notReady: !_vm.formReady },
                    on: { click: _vm.calculate }
                  },
                  [_vm._v("\n            生成幸運地圖\n          ")]
                )
              ])
            ])
          ])
        ])
      : _c("div", { staticClass: "result-wrap custom-container" }, [
          _c("div", { staticClass: "result-header" }, [
            _c(
              "div",
              {
                staticClass: "personal__cancel",
                on: { click: _vm.backToForm }
              },
              [_vm._v("← 返回設定")]
            ),
            _c("div", { staticClass: "birth-info-tag" }, [
              _vm._v(_vm._s(_vm.formattedBirthDateTime))
            ])
          ]),
          _c("div", { staticClass: "result-body" }, [
            _c("div", { staticClass: "legend-panel" }, [
              _c("div", { staticClass: "legend-title" }, [
                _vm._v("行星能量線")
              ]),
              _c(
                "div",
                { staticClass: "legend-planets" },
                _vm._l(_vm.planetList, function(p) {
                  return _c(
                    "div",
                    {
                      key: p.key,
                      staticClass: "legend-item",
                      on: {
                        click: function($event) {
                          return _vm.togglePlanet(p.key)
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "legend-dot",
                        style: {
                          background: p.color,
                          opacity: _vm.visiblePlanets[p.key] ? 1 : 0.2
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "legend-name",
                          class: { dimmed: !_vm.visiblePlanets[p.key] }
                        },
                        [_vm._v(_vm._s(p.zh))]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._m(2),
              _vm.clickedLocation
                ? _c("div", { staticClass: "location-info" }, [
                    _c("div", { staticClass: "legend-subtitle" }, [
                      _vm._v("點擊位置")
                    ]),
                    _c("div", { staticClass: "location-coords" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatLat(_vm.clickedLocation.lat)) +
                          ",\n            " +
                          _vm._s(_vm.formatLng(_vm.clickedLocation.lng)) +
                          "\n          "
                      )
                    ]),
                    _vm.geocodingLoading
                      ? _c("div", { staticClass: "location-city" }, [
                          _c("span", { staticClass: "geocoding-hint" }, [
                            _vm._v("查詢地名中…")
                          ])
                        ])
                      : _vm.nearestCity
                      ? _c("div", { staticClass: "location-city" }, [
                          _vm._v("\n            地點："),
                          _c("strong", [_vm._v(_vm._s(_vm.nearestCity))])
                        ])
                      : _vm._e(),
                    _vm.clickedTzDisplay
                      ? _c("div", { staticClass: "location-tz" }, [
                          _vm._v("\n            法定時區："),
                          _c("strong", [_vm._v(_vm._s(_vm.clickedTzDisplay))])
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "location-btns" }, [
                      _c(
                        "div",
                        {
                          staticClass: "location-btn",
                          class: { loading: _vm.relocationLoading },
                          on: { click: _vm.loadRelocation }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.relocationLoading ? "計算中…" : "查看重置盤"
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "map-container" },
              [
                _vm.calculating
                  ? _c("div", { staticClass: "map-loading" }, [
                      _c("div", { staticClass: "loading-spinner" }),
                      _c("span", [_vm._v("計算行星軌跡中…")])
                    ])
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "locate-btn",
                    class: { locating: _vm.locating },
                    attrs: { title: _vm.locating ? "定位中…" : "定位我的位置" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.locateMe.apply(null, arguments)
                      }
                    }
                  },
                  [
                    !_vm.locating
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }
                          },
                          [
                            _c("circle", {
                              attrs: { cx: "12", cy: "12", r: "3" }
                            }),
                            _c("path", {
                              attrs: { d: "M12 2v3M12 19v3M2 12h3M19 12h3" }
                            }),
                            _c("circle", {
                              attrs: {
                                cx: "12",
                                cy: "12",
                                r: "8",
                                "stroke-opacity": "0.4"
                              }
                            })
                          ]
                        )
                      : _c("span", { staticClass: "locate-spinner" })
                  ]
                ),
                _c(
                  "l-map",
                  {
                    ref: "leafletMap",
                    staticClass: "leaflet-map",
                    attrs: {
                      zoom: _vm.zoom,
                      center: _vm.center,
                      options: _vm.mapOptions
                    },
                    on: {
                      click: _vm.onMapClick,
                      ready: _vm.onMapReady,
                      "update:zoom": function($event) {
                        _vm.zoom = $event
                      }
                    }
                  },
                  [
                    _c("l-tile-layer", {
                      attrs: {
                        url: _vm.tileUrl,
                        attribution: _vm.tileAttribution,
                        options: _vm.tileOptions
                      }
                    }),
                    _vm.zoom >= 4
                      ? _vm._l(_vm.cityDotList, function(city) {
                          return _c(
                            "l-circle-marker",
                            {
                              key: city.name,
                              staticClass: "city-dot",
                              attrs: {
                                "lat-lng": [city.lat, city.lng],
                                radius: 6,
                                color: "#fff",
                                "fill-color": "#ff8c42",
                                "fill-opacity": 0.9,
                                weight: 1.5
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onCityClick(city)
                                }
                              }
                            },
                            [
                              _c(
                                "l-tooltip",
                                {
                                  attrs: {
                                    options: {
                                      direction: "top",
                                      sticky: false,
                                      className: "city-tooltip"
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(city.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        })
                      : _vm._e(),
                    _vm._l(_vm.filteredFeatures, function(feature) {
                      return [
                        _c(
                          "l-polyline",
                          {
                            key: feature._id,
                            attrs: {
                              "lat-lngs": _vm.featureLatLngs(feature),
                              color: feature.properties.color,
                              weight: _vm.lineWeight(feature.properties.angle),
                              "dash-array": _vm.lineDash(
                                feature.properties.angle
                              ),
                              opacity: 0.85
                            }
                          },
                          [
                            _c(
                              "l-tooltip",
                              {
                                attrs: {
                                  options: { sticky: true, direction: "top" }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(feature.properties.label) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }),
                    _vm.clickedLocation
                      ? _c("l-circle-marker", {
                          attrs: {
                            "lat-lng": [
                              _vm.clickedLocation.lat,
                              _vm.clickedLocation.lng
                            ],
                            radius: 7,
                            color: "#fff",
                            "fill-color": "#ee6daf",
                            "fill-opacity": 1,
                            weight: 2
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ]),
          _vm.relocationAstralInfo
            ? _c("div", { staticClass: "relocation-result" }, [
                _c("div", { staticClass: "relocation-result__header" }, [
                  _c("div", { staticClass: "relocation-result__title" }, [
                    _vm._v("重置盤")
                  ]),
                  _c("div", { staticClass: "relocation-result__info" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formattedBirthDateTime) +
                        "\n          "
                    ),
                    _vm.nearestCity
                      ? _c("span", [_vm._v(" · " + _vm._s(_vm.nearestCity))])
                      : _vm._e(),
                    _vm.clickedTzDisplay
                      ? _c("span", [_vm._v(" " + _vm._s(_vm.clickedTzDisplay))])
                      : _vm._e()
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "relocation-result__body" },
                  [
                    _c(
                      "div",
                      { staticClass: "relocation-params" },
                      [
                        _c("Params", {
                          attrs: {
                            TcAstralInfo: _vm.relocationAstralInfo,
                            AstrolabeType: "C2",
                            role: "Relocation",
                            moondayObj: _vm.relocationMoondayObj
                          }
                        })
                      ],
                      1
                    ),
                    _c("NewAstrolabe", {
                      attrs: {
                        data1: _vm.relocationAstralInfo.AstralRadians,
                        data2: null,
                        type: 0,
                        styleArray: _vm.relocationStyleArray,
                        role: "Relocation",
                        Ret1: _vm.relocationAstralInfo.RetAstralSet,
                        showNowTime: false,
                        format_time: _vm.formattedBirthDateTime,
                        mode: "astrometryMode",
                        nowTimeNowPlaceBtn: false,
                        nowTimeNowPlaceIng: false,
                        nowPlace: _vm.clickedPlaceDisplay,
                        moondayObj: _vm.relocationMoondayObj,
                        hiddenuserDesktopInfo: true
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header custom-container" }, [
      _c("span", [_vm._v("ACG 幸運地圖")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "acg-intro" }, [
      _vm._v(
        "\n          根據您的出生資料，在全球地圖上畫出 10 顆行星的「幸運能量線」。"
      ),
      _c("br"),
      _vm._v(
        "\n          住在某條線上，代表該行星能量在當地得到強化。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend-angles" }, [
      _c("div", { staticClass: "legend-subtitle" }, [_vm._v("線型說明")]),
      _c("div", { staticClass: "legend-angle-item" }, [
        _c("span", { staticClass: "line-sample solid" }),
        _vm._v(" MC（中天）\n          ")
      ]),
      _c("div", { staticClass: "legend-angle-item" }, [
        _c("span", { staticClass: "line-sample dashed" }),
        _vm._v(" IC（天底）\n          ")
      ]),
      _c("div", { staticClass: "legend-angle-item" }, [
        _c("span", { staticClass: "line-sample dotted" }),
        _vm._v(" ASC（上升）\n          ")
      ]),
      _c("div", { staticClass: "legend-angle-item" }, [
        _c("span", { staticClass: "line-sample dash-dot" }),
        _vm._v(" DSC（下降）\n          ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }